import { COOKIE_SERVICE as g, StringFormat as f } from "@packages/common";
import { CONFIG as m } from "@packages/config";
import { Injectable as a, Inject as u } from "@webmotors/ioc";
import { GEOLOCATION_COOKIE_SERVICE as p } from "./main22.js";
var O = Object.getOwnPropertyDescriptor, C = (e, r, o, t) => {
  for (var n = t > 1 ? void 0 : t ? O(r, o) : r, i = e.length - 1, l; i >= 0; i--)
    (l = e[i]) && (n = l(n) || n);
  return n;
}, s = (e, r) => (o, t) => r(o, t, e);
let c = class {
  /**
   * Constructs the GeolocationCookieService with the necessary dependencies.
   * @param cookie - The CookieService instance for managing cookies.
   * @param config - The application configuration instance.
   */
  constructor(e, r) {
    this.cookie = e, this.config = r;
  }
  /**
   * Retrieves geolocation data from the cookie.
   * @returns An object containing the geolocation data parsed from the cookie.
   * If the cookie is invalid or missing, default values are returned.
   */
  get() {
    const e = {
      state: null,
      city: null,
      location: {
        latitude: null,
        longitude: null,
        radius: null
      }
    }, r = this.cookie.get(
      this.config.geolocationCookieName
    );
    if (!r)
      return e;
    try {
      const { estadocidade: o, localizacao: t = {} } = r;
      if (typeof o != "string")
        return e;
      const [n, i] = ((o == null ? void 0 : o.split(" - ")) ?? []).map(
        (l) => l ? f.formatSlug(l) : null
      );
      return {
        state: n,
        city: i,
        location: {
          latitude: (t == null ? void 0 : t.latitude) ?? null,
          longitude: (t == null ? void 0 : t.longitude) ?? null,
          radius: (t == null ? void 0 : t.raio) ?? null
        }
      };
    } catch {
      return e;
    }
  }
};
c = C([
  a(p),
  s(0, u(g)),
  s(1, u(m))
], c);
export {
  c as GeolocationCookieService
};
